import { Document, IDocumentsPayload } from '../utils/types/state-types';
import api from './api';

async function getDocumentsAPI(): Promise<IDocumentsPayload> {
  const response = await api.get('documents/');
  const documents = {} as IDocumentsPayload;
  response?.data
    .filter((doc: Document | null) => !!doc)
    // eslint-disable-next-line no-return-assign
    .forEach((doc: Document) => (documents[`document${doc.type}`] = doc.file));
  return documents;
}

export default getDocumentsAPI;
